import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  Card,
  Icon,
  Pagination,
  Dropdown,
  Menu,
  Collapse,
  Checkbox,
  Button,
  Tag,
  Switch,
  Spin,
} from 'antd';
import io from 'socket.io-client';
import PropTypes from 'prop-types';
import ImageCanvas from './Component/ImageCanvas';
import ImageLoader from './Component/ImageLoader';
import InferenceSettings from './Component/InferenceSettings';
import { runtimeExport } from '../RuntimeHistory/RuntimeHistory.saga';
import {
  inferenceStop,
  fetchInference,
  fetchLabels,
  predictInference,
  startStreaming,
  stopStreaming,
} from './Inference.saga';
import { updateInferenceStatus } from './Inference.reducer';
import { storeModelDetails } from '../Login/Login.reducer';
import ConfirmActionPopup from '../../Components/Popup/ConfirmPopup';
import { formatDuration, formatTime } from '../../Utils/Format';
import placeholder from './assets/placeholder.svg';
import styles from './Inference.module.css';
import './Inference.css';
import LiveFeed from '../../Components/LiveFeed';

const { Item } = Menu;
const { Panel } = Collapse;
const SOCKET_URL = window.location.origin;

function Inference({
  fetchInferenceAction,
  updateInferenceStatusAction,
  storeModelDetailsAction,
  location,
  fetchLabelsAction,
  runtimeExportAction,
  inferenceStopAction,
  predictInferenceAction,
  startStreamingAction,
  stopStreamingAction,
  inferenceDetails,
  showRedundantViews,
  match,
}) {
  const [max, setMax] = useState(false);
  const [status] = useState(null);
  const [filterList, setFilterList] = useState({
    Labels: [],
  });
  const [stopPopupShow, setStopPopupShow] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inferenceList, setInferenceList] = useState([]);
  const [currentFilter, setCurrentFilter] = useState([]);
  const [filterStore, setFilterStore] = useState([]);
  const [inferenceListStore, setInferenceListStore] = useState([]);
  const [selectedImage, setSelectedImage] = useState({});
  const [goLive, setGoLive] = useState(true);
  const [info, setInfo] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [recordShow, setRecordShow] = useState(false);
  const [isComplete, setIsComplete] = useState(true);
  const [streaming, setStreaming] = useState(false);
  const [streamImage, setStreamImage] = useState('');
  const [showHeatmap, setShowHeatmap] = useState(false);
  const [geminiModel, setGeminiModel] = useState(false);
  const goLiveRef = useRef();
  const badLabelId = useRef();
  const [inferenceParams, setInferenceParams] = useState({
    offset: 0,
    size: 10,
  });
  const [socketData, setSocketData] = useState({
    failPercent: 0,
    imageCount: 0,
    sessionTime: 0,
    passPercent: 0,
    modelDefects: [],
    modelLearningMode: '',
    totalNumberOfImages: 0,
  });
  let socket = null;
  let streamSocket = null;
  const fileInputRef = useRef();
  const runtimeId = location?.pathname.split('/').slice(-1)[0];
  const {
    defectmap,
    inferredAt,
    labelName,
    originalImage,
    imageId,
    labelColor,
    heatmapImage,
    errorMessage,
  } = selectedImage || {};
  const inferredDate = inferredAt && new Date(inferredAt);
  const isInferenceListEmpty = inferenceList.length === 0;
  let heatmapImageUrl = null;
  if (heatmapImage && heatmapImage[0]) {
    if (/\.[a-zA-Z]+$/.test(heatmapImage[0])) {
      heatmapImageUrl = heatmapImage[0];
    } else {
      heatmapImageUrl = `${heatmapImage[0]}.jpeg`;
    }
  }
  // let imageMap = '';
  // if (geminiModel) {
  //   imageMap = originalImage;
  // } else if (labelName === 'Good') {
  //   imageMap = originalImage;
  // } else if (labelName === 'Bad') {
  //   imageMap = defectmap;
  // } else {
  //   imageMap = originalImage;
  // }
  // const displayImage =
  //   showHeatmap && heatmapImageUrl ? heatmapImageUrl : imageMap;

  const imageMap = (() => {
    if (geminiModel) {
      return originalImage;
    }
    if (labelName === 'Good') {
      return originalImage;
    }
    if (labelName === 'Bad') {
      return defectmap;
    }
    return originalImage;
  })();

  const displayImage =
    showHeatmap && heatmapImageUrl ? heatmapImageUrl : imageMap;

  const { runtimeStatus, runtimeUuid } = inferenceDetails || {};
  const completed = runtimeStatus === 'Completed' ?? true;
  const {
    failPercent,
    totalNumberOfImages,
    passPercent,
    sessionTime,
    modelDefects,
    modelLearningMode,
    imageCount,
  } = socketData;
  const { offset, size } = inferenceParams;
  goLiveRef.current = goLive;
  const {
    params: { modelId },
  } = match;

  const initSocket = (runtimeUuidVal) => {
    socket = io(SOCKET_URL, {
      path: '/connect/',
    });

    socket.on('connect', () => {
      console.log('connected');
    });

    socket.on(`online-inference/${runtimeUuidVal}`, (data) => {
      const { current } = goLiveRef;
      if (current) {
        const { labelName: latestLabelName } = data;
        if (latestLabelName === 'Bad') {
          const {
            failPercent: latestFailPercent,
            imageCount: latestImageCount,
            sessionTime: latestSessionTime,
            passPercent: latestPassPercent,
          } = data;
          setSocketData({
            failPercent: latestFailPercent,
            imageCount: latestImageCount,
            sessionTime: latestSessionTime,
            passPercent: latestPassPercent,
            totalNumberOfImages: totalNumberOfImages + 1,
          });
          setSelectedImage(data);
          setInferenceList((prevList) => [data, ...prevList].slice(0, size));
        }
      } else {
        let dataList = [];
        if (!inferenceListStore.length) {
          dataList = [data, ...inferenceList].slice(0, size);
        } else {
          dataList = [data, ...inferenceListStore].slice(0, size);
        }
        setInferenceListStore(dataList);
      }
    });

    socket.on('disconnect', () => {
      console.log('disconnected');
    });
  };

  const handleFetchInference = (
    id,
    updatedOffset,
    updatedSize,
    updatedFilter
  ) => {
    let filter = updatedFilter || currentFilter;

    if (filter.length === 2 || !filter.length) {
      filter = '';
    } else {
      [filter] = filter;
    }

    fetchInferenceAction({
      data: {
        id,
        offset: updatedOffset ?? offset,
        size: updatedSize || size,
        filterByLabel: filter,
      },
      callback: (data) => {
        const {
          failPercent: latestFailPercent,
          imageCount: latestImageCount,
          sessionTime: latestSessionTime,
          passPercent: latestPassPercent,
          modelDefects: latestModelDefects,
          modelLearningMode: latestModelLearningMode,
          inferenceStatus: latestInferenceStatus,
          modelName: latestModelName,
          totalNumberOfImages: latestTotalNumberOfImages,
          geminiModel: latestGeminiModel,
        } = data;
        setShowHeatmap(latestGeminiModel);
        setGeminiModel(latestGeminiModel);
        setIsComplete(latestInferenceStatus === 'Completed');
        setSocketData({
          failPercent: latestFailPercent,
          imageCount: latestImageCount,
          modelDefects: latestModelDefects,
          modelLearningMode: latestModelLearningMode,
          passPercent: latestPassPercent,
          sessionTime: latestSessionTime,
          totalNumberOfImages: latestTotalNumberOfImages,
        });
        setSelectedImage(data.imageDetailsList && data.imageDetailsList[0]);
        setInferenceList(data.imageDetailsList);
        updateInferenceStatusAction(latestInferenceStatus);
        storeModelDetailsAction({
          modelName: latestModelName,
        });
      },
    });
  };

  const handleFetchLabels = () => {
    fetchLabelsAction({
      callback: (labels) => {
        const badLabel = labels.find((label) => label.labelName === 'Bad');
        badLabelId.current = badLabel ? badLabel.labelUuid : null;

        setFilterList({
          Labels: labels,
        });

        if (badLabelId.current) {
          setCurrentFilter([badLabelId.current]);
          setFilterStore([badLabelId.current]);
          handleFetchInference(runtimeId, null, null, [badLabelId.current]);
        } else {
          setCurrentFilter([]);
          setFilterStore([]);
          handleFetchInference(runtimeId, null, null, []);
        }
      },
    });
  };

  const closeSocket = () => {
    if (socket != null) {
      socket.disconnect();
    }
  };

  useEffect(() => {
    if (geminiModel) return;
    setGoLive(!isComplete);
    if (!isComplete) {
      initSocket(runtimeId);
    }
  }, [isComplete]);

  useEffect(() => {
    handleFetchLabels();
    return () => {
      closeSocket();
    };
  }, []);

  useEffect(() => {
    if (document.getElementById(selectedImage.id)) {
      document.getElementById(selectedImage.id).scrollIntoView();
    }
  }, [selectedImage?.id]);

  useEffect(() => {
    if (geminiModel) return;
    if (streaming) {
      startStreamingAction({
        payload: modelId,
      });
      streamSocket = io(SOCKET_URL, {
        path: '/connect/',
      });

      streamSocket.on('connect', () => {
        console.log('connected');
      });

      streamSocket.on(`online-inference/${modelId}`, (data) => {
        setStreamImage(data);
      });
      // } else {
      //   console.log('Stopping streaming Inside else statement');
      //   stopStreamingAction({
      //     payload: modelId,
      //   });
    }
    return () => {
      if (streamSocket != null) {
        streamSocket.disconnect();
      }
    };
  }, [streaming]);

  const exportRuntime = () => {
    runtimeExportAction(1);
  };

  const inferenceModelClose = () => {
    setStopPopupShow(false);
    setPopupLoading(false);
  };

  const stopInference = () => {
    setPopupLoading(true);
    inferenceStopAction({
      payload: modelId,
      callback: () => {
        setGoLive(false);
        closeSocket();
        inferenceModelClose();
      },
    });
  };

  const getImageMap = (labelName, originalImage, defectmap, geminiModel) => {
    if (geminiModel) return originalImage;
    if (labelName === 'Good') return originalImage;
    if (labelName === 'Bad') return defectmap;
    return originalImage;
  };

  const handlePagination = (offsetVal, mode) => {
    setInferenceParams((prevParams) => ({
      ...prevParams,
      offset: offsetVal - 1,
    }));
    if (mode) {
      handleFetchInference(runtimeUuid, offsetVal - 1, null, [
        badLabelId.current,
      ]);
    } else {
      handleFetchInference(runtimeUuid, offsetVal - 1);
    }
  };

  const handleGoLiveOn = (goLiveVal) => {
    setGoLive(goLiveVal);
    if (goLiveVal) {
      const badInferences = [...inferenceListStore, ...inferenceList].filter(
        (inference) => inference.labelName === 'Bad'
      );
      setInferenceParams({
        offset: 0,
        size: 10,
      });
      setSelectedImage((badInferences.length > 0 && badInferences[0]) || {});
      setInferenceList(badInferences);
      setInferenceListStore([]);

      if (badLabelId.current) {
        setCurrentFilter([badLabelId.current]);
        setFilterStore([badLabelId.current]);
        if (offset !== 0 || currentFilter[0] !== badLabelId.current) {
          handlePagination(1, true);
        }
      } else {
        setCurrentFilter([]);
        setFilterStore([]);
        if (offset !== 0 || currentFilter.length > 0) {
          handlePagination(1, true);
        }
      }
    }
  };

  const handleInferencePredict = () => {
    fileInputRef.current.click();
    // predictInferenceAction({
    //   payload: modelId,
    //   callback: () => {
    //     //
    //   },
    // });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoading(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Image = reader.result.split(',')[1];
        const payload = {
          image: base64Image,
          imageDataType: 'base64',
          modelUuid: modelId,
          generateHeatmaps: true,
          generateLabels: true,
        };
        predictInferenceAction({
          payload,
          callback: (val) => {
            if (val === 200) {
              handleFetchLabels();
              setLoading(false);
            } else {
              setLoading(false);
            }
          },
        });
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className={`${styles.container} ${max && styles.containerMax}`}>
      <div
        className={styles.maxWidthHeight}
        style={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <div
          style={{
            height: '100%',
            width: '60%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '100%',
            }}
            // className={goLive && 'disableCursorShow'}
          >
            <div className={styles.settingsContainer}>
              {showRedundantViews && <InferenceSettings />}
            </div>
            <div
              className={`${styles.canvasContainer} ${
                goLive && 'disableEvent'
              }`}
              style={{
                height: 'calc(100% - 22px)',
                width: '70%',
                border: `2px solid ${
                  selectedImage ? labelColor : 'var(--color-c3)'
                }`,
              }}
            >
              <div className={styles.canvasHeader}>
                {/* <div className="imageLabel" style={{ background: selectedImage && selectedImage.color, margin: "5px 10px" }} />Score 8.17 */}
                <span
                  className="flaticon-info"
                  onClick={() => setInfo((prevInfo) => !prevInfo)}
                  style={{ marginRight: 8 }}
                />
                <span>{errorMessage || ''}</span>
              </div>
              <div
                style={{
                  height: 'calc(100% - 42px)',
                  width: '100%',
                }}
              >
                {console.log(displayImage, 'displayImage')}
                <ImageCanvas info={info} imageSrc={displayImage} />
                {info && (
                  <div
                    className={styles.inferenceMetric}
                    style={{
                      padding: '25px 50px',
                      zoom: '0.8',
                    }}
                  >
                    {[
                      {
                        label: 'Inferred date',
                        name: (
                          <span>
                            {inferredDate && inferredDate.getDate()
                              ? `${inferredDate.getDate()}-${
                                  inferredDate.getMonth() + 1
                                }-${inferredDate.getFullYear()}`
                              : '--'}
                          </span>
                        ),
                      },
                      {
                        label: 'Inferred time',
                        name: (
                          <span>
                            {inferredDate
                              ? `${formatTime(inferredDate)}`
                              : '--'}
                          </span>
                        ),
                      },
                    ].map((item) => (
                      <div
                        style={{
                          width: '200px',
                        }}
                      >
                        <span
                          style={{
                            color: 'rgba(255,255,255,0.5)',
                          }}
                        >
                          {item.label}
                        </span>
                        <br />
                        <div
                          style={{
                            color: '#ffffff',
                            fontSize: '22px',
                            marginBottom: '10px',
                          }}
                        >
                          {item.name}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '40%',
          }}
        >
          <Collapse
            defaultActiveKey={['1']}
            className={styles.collapse}
            bordered={false}
            onChange={() => setCollapse((prevCollapse) => !prevCollapse)}
          >
            <Panel
              extra={
                <>
                  {showRedundantViews && (
                    <span
                      className="exportText"
                      onClick={(e) => {
                        exportRuntime();
                        e.stopPropagation();
                      }}
                    >
                      Export Result
                    </span>
                  )}
                  {!completed && (
                    <>
                      <Button
                        className={
                          streaming ? 'streamStopText' : 'streamStartText'
                        }
                        onClick={(e) => {
                          setStreaming((prevStreaming) => !prevStreaming);
                          e.stopPropagation();
                        }}
                      >
                        {streaming ? 'Stop Streaming' : 'Start Stream'}
                      </Button>
                      {loading && (
                        <div
                          style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'rgba(0,0,0,0.2)',
                            zIndex: 9999,
                          }}
                        >
                          <Spin size="large" />
                        </div>
                      )}
                      <Button
                        className="predictText"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleInferencePredict();
                        }}
                      >
                        Predict
                      </Button>
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                      />
                    </>
                  )}
                  <Dropdown
                    overlay={
                      <div
                        className={`${styles.filterWrapper} ${styles.evaluateFilterWrapper}`}
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <div
                          className={styles.filterListWrapper}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {Object.keys(filterList).map((val) => {
                            if (filterList[val] && filterList[val].length) {
                              return (
                                <div className={styles.filterList}>
                                  <p
                                    style={{
                                      alignItems: 'center',
                                      display: 'flex',
                                    }}
                                  >
                                    {val}
                                    <Icon
                                      style={{
                                        marginLeft: 'auto',
                                      }}
                                      type="undo"
                                      onClick={() => {
                                        if (!goLive) {
                                          setCurrentFilter([]);
                                        }
                                      }}
                                      className={goLive && 'disableCursorShow'}
                                    />
                                  </p>
                                  <Checkbox.Group
                                    options={filterList[val].map((item) => {
                                      const prefix = val
                                        .toLowerCase()
                                        .slice(0, val.length - 1);
                                      return {
                                        label: (
                                          <span
                                            style={{
                                              color: 'white',
                                              fontSize: '11px',
                                            }}
                                          >
                                            {item[`${prefix}Color`] && (
                                              <div
                                                style={{
                                                  background:
                                                    item[`${prefix}Color`],
                                                }}
                                                className={styles.colorPallete}
                                              />
                                            )}
                                            {item[`${prefix}Name`]}
                                          </span>
                                        ),
                                        value: item[`${prefix}Uuid`],
                                      };
                                    })}
                                    onChange={(filterValue) =>
                                      setCurrentFilter(filterValue)
                                    }
                                    value={currentFilter}
                                    className="rememberMeCheck"
                                    disabled={goLive}
                                  />
                                </div>
                              );
                            }
                            return '';
                          })}
                        </div>
                        <div className={styles.dropdownFooter}>
                          <Button
                            className={styles.dropdownCancelButton}
                            onClick={(e) => {
                              setFilterVisible(false);
                              setCurrentFilter(filterStore);
                              e.stopPropagation();
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            disabled={goLive}
                            className={styles.dropdownApplyButton}
                            onClick={(e) => {
                              setFilterVisible(false);
                              setFilterStore(currentFilter);
                              e.stopPropagation();
                              handlePagination(1);
                            }}
                          >
                            Apply
                          </Button>
                        </div>
                      </div>
                    }
                    onClick={(e) => {
                      setFilterVisible((prevVisiblity) => !prevVisiblity);
                      e.stopPropagation();
                    }}
                    visible={filterVisible}
                    onVisibleChange={(visible) => {
                      if (!visible) {
                        setFilterVisible(visible);
                        setCurrentFilter(filterStore);
                      }
                    }}
                    trigger={['click']}
                    placement="bottomCenter"
                  >
                    <span className="flaticon-filter" />
                  </Dropdown>
                  <Icon
                    type={max ? 'shrink' : 'arrows-alt'}
                    className={styles.max}
                    onClick={(e) => {
                      setMax((prevMax) => !prevMax);
                      e.stopPropagation();
                    }}
                  />
                </>
              }
              key="1"
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 16,
                }}
              >
                <span
                  style={{ color: 'rgba(255, 255, 255, 0.5)', marginRight: 8 }}
                >
                  Show Heatmap
                </span>
                <Switch
                  checked={showHeatmap}
                  onChange={() => setShowHeatmap(!showHeatmap)}
                  checkedChildren="Show"
                  unCheckedChildren="Hide"
                />
              </div>

              <div className={styles.inferenceMetricContainer}>
                <div className={styles.inferenceMetric}>
                  <div
                    style={{
                      width: '100%',
                    }}
                  >
                    <span
                      style={{
                        color: 'rgba(255,255,255,0.5)',
                      }}
                    >
                      Session time
                    </span>
                    <br />
                    <div
                      style={{
                        color: '#ffffff',
                        fontSize: '22px',
                        marginBottom: '10px',
                      }}
                    >
                      {sessionTime != null && !isInferenceListEmpty
                        ? `${formatDuration(sessionTime)}`
                        : '--'}
                    </div>
                  </div>
                  {!completed && (
                    <div
                      style={{
                        width: '100px',
                      }}
                    >
                      <span
                        style={{
                          color: 'rgba(255,255,255,0.5)',
                        }}
                      >
                        Status
                      </span>
                      <br />
                      <div
                        style={{
                          color:
                            status === 'pause' ? 'orange' : 'rgb(58, 181, 74)',
                          fontSize: '22px',
                          marginBottom: '10px',
                        }}
                      >
                        {status === 'pause' ? 'Paused' : 'Online'}
                      </div>
                    </div>
                  )}
                  {[
                    {
                      label: 'Image Count',
                      value:
                        imageCount != null && !isInferenceListEmpty
                          ? imageCount
                          : '--',
                    },
                    {
                      label: 'Pass',
                      value:
                        passPercent != null && !isInferenceListEmpty
                          ? `${passPercent.toFixed(2)}%`
                          : '--',
                    },
                    {
                      label: 'Fail',
                      value:
                        failPercent != null && !isInferenceListEmpty
                          ? `${failPercent.toFixed(2)}%`
                          : '--',
                    },
                  ].map((item) => (
                    <div
                      style={{
                        width: '100px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <span
                        style={{
                          color: 'rgba(255,255,255,0.5)',
                        }}
                      >
                        {item.label}
                      </span>
                      <br />
                      <div
                        style={{
                          color: '#ffffff',
                          fontSize: '22px',
                          marginBottom: '10px',
                        }}
                      >
                        {item.value}
                      </div>
                    </div>
                  ))}
                  {runtimeStatus === 'Online' && (
                    <>
                      <div style={{ width: '9.6rem' }}>
                        <span style={{ color: 'rgba(255,255,255,0.5)' }}>
                          Go Live
                        </span>
                        <Switch
                          checked={goLive}
                          className="goLiveSwitch"
                          checkedChildren="On"
                          unCheckedChildren="Off"
                          onChange={handleGoLiveOn}
                        />
                      </div>
                      <Button
                        className={styles.stopButton}
                        type="danger"
                        size="large"
                        onClick={() => setStopPopupShow(true)}
                      >
                        Stop
                      </Button>
                    </>
                  )}
                </div>
                {modelLearningMode === 'Guided' && (
                  <div className={styles.defectContainer}>
                    <div className={styles.defectDropdown}>
                      <div
                        className={styles.statisticsHeading}
                        style={{
                          marginLeft: '6px',
                          color: 'white',
                        }}
                      >
                        Defects
                      </div>
                      {modelDefects &&
                        modelDefects.length > 0 &&
                        modelDefects.map((defect) => (
                          <Tag
                            key={defect.defectUuid}
                            className={styles.fieldTags}
                          >
                            <span className="rememberMeCheck typeMeCheck">
                              <span className={styles.defectItem}>
                                <div
                                  className={styles.colorBox}
                                  style={{
                                    background: defect.defectColor,
                                  }}
                                />
                                {defect.defectName}
                              </span>
                            </span>
                          </Tag>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </Panel>
          </Collapse>
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: collapse ? 'calc(100% - 50px)' : 'calc(75% - 50px)',
              marginTop: '10px',
            }}
          >
            <div
              style={{
                width: '100%',
              }}
            >
              {/* ${
                  goLive && 'disableCursorShow'
                } */}
              <div
                className={`${styles.imageBody} `}
                style={{
                  height: '100%',
                  width: '100%',
                  flexDirection: 'row',
                  paddingBottom: '100px',
                }}
              >
                {/*  ${ goLive && 'disableEvent'}
                 */}
                <div
                  className={`${styles.inferenceListContainer} 
                  `}
                >
                  {!isInferenceListEmpty ? (
                    inferenceList.map((item) => {
                      const {
                        inferredAt: itemInferredAt,
                        defectmap: itemDefectmap,
                        originalImage: itemOriginalImage,
                        labelName: itemLabelName,
                      } = item;
                      const itemDate =
                        itemInferredAt && itemInferredAt > 0
                          ? new Date(itemInferredAt)
                          : null;
                      const itemMap = getImageMap(
                        itemLabelName,
                        itemOriginalImage,
                        itemDefectmap,
                        geminiModel
                      );

                      // let itemMap = '';
                      // if (geminiModel) {
                      //   itemMap = itemOriginalImage;
                      // } else if (itemLabelName === 'Good') {
                      //   itemMap = itemOriginalImage;
                      // } else if (itemLabelName === 'Bad') {
                      //   itemMap = itemDefectmap;
                      // } else {
                      //   itemMap = itemOriginalImage;
                      // }
                      // item.score = (Math.random() * 10).toFixed(2);
                      return (
                        <Card
                          id={item.imageId}
                          onMouseEnter={() => {
                            document.getElementById(
                              item.imageId
                            ).style.borderColor = item?.labelColor;
                          }}
                          onMouseLeave={() => {
                            if (imageId !== item.imageId) {
                              document.getElementById(
                                item.imageId
                              ).style.borderColor = null;
                            }
                          }}
                          className="cardWrapper"
                          style={{
                            borderColor:
                              imageId === item.imageId && item?.labelColor,
                          }}
                          cover={
                            <ImageLoader
                              style={{
                                objectFit: 'cover',
                              }}
                              src={itemMap}
                              onClick={() => {
                                console.log(item, 'item On Click');
                                setSelectedImage(item);
                              }}
                              onError={(e) => {
                                e.target.src = placeholder;
                              }}
                            />
                          }
                          actions={[
                            // <div className="imageLabel" style={{ background: item.color }} />,
                            // <div className={styles.score} >
                            // 	Score {item.score ? item.score : '-'}
                            // </div>
                            <div className={styles.itemDate}>
                              {itemDate && itemDate.getDate()
                                ? `${itemDate.getDate()}-${
                                    itemDate.getMonth() + 1
                                  }-${itemDate.getFullYear()}
                                   ${formatTime(itemDate)}`
                                : '--'}
                            </div>,
                          ]}
                        />
                      );
                    })
                  ) : (
                    <div className={styles.noImages}>No Images</div>
                  )}
                </div>
              </div>
              <div
                className={styles.imageFooter}
                style={{
                  filter: 'blur(9px)',
                  width: '40%',
                }}
              />
              {/* ${goLive && 'disableCursorShow'} */}
              <div
                className={`${styles.imageFooter} `}
                style={{
                  width: '40%',
                }}
              >
                {/* ${goLive && 'disableEvent'} */}
                <div className={`${styles.records}`}>
                  <span>Showing</span>
                  <div className={styles.total}>
                    <Dropdown
                      overlay={() => (
                        <Menu className="tableDropdown">
                          {new Array(Math.ceil(totalNumberOfImages / 10))
                            .fill('')
                            .map((item, i) => (
                              <Item
                                onClick={() => {
                                  setRecordShow(false);
                                  setInferenceParams({
                                    offset: 0,
                                    size: (i + 1) * 10,
                                  });
                                  handleFetchInference(
                                    runtimeUuid,
                                    0,
                                    (i + 1) * 10
                                  );
                                }}
                              >
                                1-
                                {(i + 1) * 10}
                              </Item>
                            ))}
                        </Menu>
                      )}
                      onClick={() => {
                        if (totalNumberOfImages > 10) {
                          setRecordShow((prevRecordShow) => !prevRecordShow);
                        }
                      }}
                      visible={recordShow}
                    >
                      <span
                        style={{
                          opacity: 1,
                          cursor: totalNumberOfImages > 10 && 'pointer',
                        }}
                      >
                        {offset * size + +!!inferenceList.length}-
                        {offset * size + inferenceList.length}
                      </span>
                    </Dropdown>
                    <span
                      style={{
                        opacity: 0.4,
                      }}
                    >
                      {' '}
                      /{totalNumberOfImages}
                    </span>
                  </div>
                </div>
                <Pagination
                  onChange={handlePagination}
                  className={`imagePagination ${goLive && 'disableEvent'}`}
                  size="small"
                  total={totalNumberOfImages}
                  itemRender={(current, type, elem) => {
                    if (type === 'prev') {
                      return (
                        <span
                          className={`pageNavigate flaticon-back ${
                            goLive && 'disableEvent'
                          }`}
                        />
                      );
                    }
                    if (type === 'next') {
                      return (
                        <span
                          className={`pageNavigate flaticon-arrow-right ${
                            goLive && 'disableEvent'
                          }`}
                        />
                      );
                    }
                    return elem;
                  }}
                  current={offset + 1}
                  pageSize={size}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {stopPopupShow && (
        <ConfirmActionPopup
          title="Stop Inference"
          visible={stopPopupShow}
          actionType="stop inference for"
          content="model"
          onCancel={inferenceModelClose}
          onConfirm={stopInference}
          loading={popupLoading}
          loadingText="Stopping Inference"
        />
      )}
      {streaming && <LiveFeed src={streamImage} />}
    </div>
  );
}

Inference.defaultProps = {
  fetchInferenceAction: (f) => f,
  updateInferenceStatusAction: (f) => f,
  storeModelDetailsAction: (f) => f,
  location: {
    pathname: '',
  },
  fetchLabelsAction: (f) => f,
  runtimeExportAction: (f) => f,
  inferenceStopAction: (f) => f,
  predictInferenceAction: (f) => f,
  startStreamingAction: (f) => f,
  stopStreamingAction: (f) => f,
  inferenceDetails: {},
  showRedundantViews: false,
  match: {
    params: {},
  },
};

Inference.propTypes = {
  fetchInferenceAction: PropTypes.func,
  updateInferenceStatusAction: PropTypes.func,
  storeModelDetailsAction: PropTypes.func,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  fetchLabelsAction: PropTypes.func,
  runtimeExportAction: PropTypes.func,
  inferenceStopAction: PropTypes.func,
  predictInferenceAction: PropTypes.func,
  startStreamingAction: PropTypes.func,
  stopStreamingAction: PropTypes.func,
  inferenceDetails: {},
  showRedundantViews: false,
  match: PropTypes.shape({
    params: PropTypes.instanceOf(Object),
  }),
};

export default withRouter(
  connect(
    (state) => ({
      showRedundantViews: state.commonReducer.showRedundantViews,
      inferenceDetails: state.inferenceReducer.entity,
      modelId: state.inferenceReducer.modelId,
      filter: state.inferenceReducer.filter,
      location: state.router.location,
    }),
    {
      runtimeExportAction: runtimeExport,
      inferenceStopAction: inferenceStop,
      fetchInferenceAction: fetchInference,
      updateInferenceStatusAction: updateInferenceStatus,
      fetchLabelsAction: fetchLabels,
      storeModelDetailsAction: storeModelDetails,
      predictInferenceAction: predictInference,
      startStreamingAction: startStreaming,
      stopStreamingAction: stopStreaming,
    }
  )(Inference)
);
